import { useState, useCallback } from 'react';

// - This hook is named after button control that toggles content visibility - WAI ARIA: https://www.w3.org/TR/wai-aria-practices-1.1/#disclosure
/**
 * useDisclosure is a custom hook to help handle common `open`, `close`, or `toggle` scenarios
 * @returns An object of `isOpen, onOpen, onClose, onToggle`
 */
const useDisclosure = defaultIsOpen => {
  const [isOpen, setIsOpen] = useState(Boolean(defaultIsOpen));
  const onClose = useCallback(() => setIsOpen(false), []);
  const onOpen = useCallback(() => setIsOpen(true), []);
  const onToggle = useCallback(() => setIsOpen(prevIsOpen => !prevIsOpen), []);
  return {
    isOpen,
    onOpen,
    onClose,
    onToggle
  };
};

export { useDisclosure };
